import { clsx } from 'clsx';

interface NavigationItemProps {
  next?: boolean;
  onClick: () => void;
  disabled?: boolean;
}
export function NavigationItem({
  next,
  onClick,
  disabled,
}: NavigationItemProps) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      aria-label={next ? 'next slide' : 'prev slide'}
      className={clsx('w-14 h-14 slider-nav-item duration-300', {
        'pr-1 rotate-180': next,
        'pl-1': !next,
        'cursor-pointer': !disabled,
        'opacity-25': disabled,
      })}
    >
      <span className='slider-nav-item-icon w-full h-full' />
    </button>
  );
}
